import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import ConfirmationPage from '../../ConfirmationPage/ConfirmationPage';
import ExchangeWhatsNext from '../../WhatsNext/Exchange/ExchangeWhatsNext';

import { getHasMutualFundPaperlessConfirmations } from '../../../../redux/modules/user/Paperless/paperless.selectors';
import ReactDOM from 'react-dom';

const CONFIRM_PATH_SUFFIX = '/confirm';

export class ExchangeConfirmation extends Component {
  componentDidMount() {
    const { dispatchPageLoad } = this.props;
    ReactDOM.findDOMNode(this).scrollIntoView();
    dispatchPageLoad('Confirmation');
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      transactions,
      location: { pathname },
      history,
    } = nextProps;
    if (transactions.length === 0 && pathname.endsWith(CONFIRM_PATH_SUFFIX)) {
      history.push(
        pathname.substr(0, pathname.length - CONFIRM_PATH_SUFFIX.length)
      );
    }
  }

  render() {
    const {
      isIFrame,
      isSalesforceRep,
      customerWebViewEnabled,
      confirmationNumber,
      hasPaperless,
      tradeDate,
      transactions,
    } = this.props;
    // const isAppExchange = true;
    return (
      <ConfirmationPage
        isIFrame={isIFrame}
        isSalesforceRep={isSalesforceRep}
        customerWebViewEnabled={customerWebViewEnabled}
        confirmationNumber={confirmationNumber}
        hasPaperless={hasPaperless}
        heroTitle={'Your exchange request is currently pending!'}
        tradeDate={tradeDate}
        transactions={transactions}
        whatsNext={ExchangeWhatsNext}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const {
    executeExchange: { confirmationNumber, tradeDate, transactions },
  } = state;

  return {
    confirmationNumber,
    hasPaperless: getHasMutualFundPaperlessConfirmations(state),
    tradeDate,
    transactions,
  };
};

export default compose(
  connect(mapStateToProps),
  withRouter
)(ExchangeConfirmation);
